import * as Yup from 'yup'


export const EditProjectManagerSchema = Yup.object().shape({
  first_name: Yup.string().required('First name is required.'),
  last_name: Yup.string().required('Last name is required.'),
  email: Yup.string()
    .required('Email is required.')
    .email('Enter a valid email address.'),
})